export default __webpack_public_path__ + "static/media/eye.299522ce.svg";